import React from 'react'
import clsx from 'clsx'
import formStyles from 'modules/Forms/common-form.module.scss'
import { Button } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const ActionButtons = ({ submitting, onClose, accessId }) => {
  const { t } = useTranslation()
  const breakpoint = useBreakpoint()

  return (
    <div
      className={clsx(formStyles['formControl__action-buttons'], {
        ['margin-top-64']: !breakpoint.fb,
        ['margin-top-48']: breakpoint.fb,
      })}
    >
      <Button
        disabled={submitting}
        onClick={onClose}
        variant={'ghost'}
        grey
        size="l"
        type="button"
      >
        {t('common::form_buttons.cancel')}
      </Button>
      <Button
        disabled={submitting}
        size="l"
        variant="primary"
        type="submit"
        bgColor={'Label-GU-Primary'}
      >
        {t('services::forms.account_access_create.submit_button', {
          context: accessId ? 'save' : 'create',
        })}
      </Button>
    </div>
  )
}

export default ActionButtons

ActionButtons.propTypes = {
  submitting: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  accessId: PropTypes.string,
}
